import React from 'react';

const AuthorSection: React.FC = () => {
  return (
    <section className="bg-[#182b4b] text-white overflow-hidden">
      <div className="max-w-[1250px] mx-auto px-6 pt-6 pb-0 md:py-0 md:h-[200px] flex flex-col-reverse md:flex-row items-center justify-center gap-5 md:gap-8">
        <img
          src="/images/RobertBruggeman.webp"
          alt="Rob Bruggeman"
          className="h-[190px] md:h-[185px] w-auto object-contain self-center md:self-end"
        />
        <div className="pb-0 md:pb-2">
          <p className="text-[24px] md:text-[24px] leading-[1.1] font-[700] text-center md:text-left">By Rob Bruggeman, CFA</p>
          <ul className="mt-4 md:mt-3 text-[16px] leading-[1.35] text-[#bfd2ef] list-disc pl-8">
            <li>25+ years spotting winners in junior mining</li>
            <li>Former Bay Street analyst & trader</li>
            <li>Founder of The Wealthy Miner</li>
            <li>Independent Director, AbraSilver</li>
            (turned $5M -&gt; $2B+ silver success story)
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AuthorSection;
